const POST_AUTH_REDIRECT_KEY = 'postAuthRedirectPath';

const AUTH_PATH_PREFIXES = ['/login', '/callback', '/logoff', '/pages/authentication'];

const isAuthPath = (path: string): boolean => AUTH_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));

const sanitizeRedirectPath = (value?: string | null): string | null => {
  if (!value) return null;
  if (!value.startsWith('/')) return null;
  if (value.startsWith('//')) return null;
  if (isAuthPath(value)) return null;
  return value;
};

const getCurrentRelativePath = (): string => `${window.location.pathname}${window.location.search}${window.location.hash}`;

const getReturnToFromCurrentSearch = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  return sanitizeRedirectPath(params.get('returnTo'));
};

export const rememberPostAuthRedirect = (path?: string): void => {
  const currentPath = window.location.pathname;
  const existing = sanitizeRedirectPath(window.sessionStorage.getItem(POST_AUTH_REDIRECT_KEY));

  // Avoid overwriting a previously captured business route when the user is already on auth pages.
  if (isAuthPath(currentPath) && existing) {
    return;
  }

  const candidate = sanitizeRedirectPath(path) || (isAuthPath(currentPath) ? getReturnToFromCurrentSearch() : sanitizeRedirectPath(getCurrentRelativePath()));

  if (!candidate) return;

  window.sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, candidate);
};

export const consumePostAuthRedirect = (fallback = '/'): string => {
  const stored = window.sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  window.sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);

  return sanitizeRedirectPath(stored) || fallback;
};

export const getReturnToFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search);
  return sanitizeRedirectPath(params.get('returnTo'));
};
